export default function (initRequest,baseUrl) {
    return {
        postLogin: initRequest.des("登录").post("/api/Authorization/login"),
        getCaptchaCode: initRequest.des("获取验证码图片").get("/api/Authorization/captcha_code"),
        
        getMenus: initRequest.des("加载菜单").get(baseUrl + "/api/Authorization/menus"),
    }
}